module.exports = __webpack_public_path__ + "static/media/irori_sm2.a8bebe01.gif";